<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<render-layout-slot
  class="slot-header"
  [layout]="layout"
  [slot]="'header'">
</render-layout-slot>
<div
  #verticalSlider
  class="vertical-slider"
>
  <render-layout-slot
    class="slot-vertical-sliders"
    [layout]="layout"
    [slot]="'1'">
  </render-layout-slot>
  <render-layout-slot
    class="slot-footer"
    [layout]="layout"
    [slot]="'2'"
    [ngClass]="{'is-sticky': stickyFooter}">
  </render-layout-slot>
  <div
    class="bullets-holder"
    *ngIf="bullets">
    <layout-vertical-slider-bullet
      *ngFor="let slide of bulletsArray; let i = index; trackBy: trackByIndex"
      (click)="goToSlide(i + 1)"
      [selected]="isCurrentSlide(i + 1)">
    </layout-vertical-slider-bullet>
  </div>
</div>
